// src/pages/product/RelatedProduct.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getProductById } from '../../services/api';
import './RelatedProduct.css';

const RelatedProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const IMAGE_BASE_URL = 'https://demo-site.storii.com.pk/uploads/';

  useEffect(() => {
    loadProductData();
  }, [id]);

  const loadProductData = async () => {
    setLoading(true);
    try {
      const productData = await getProductById(id);
      if (productData.success && productData.product) {
        setProduct(productData.product);
        const categoryId = productData.product.category_id || productData.product.category;
        await fetchRelatedProducts(id, categoryId);
      }
    } catch (error) {
      console.error('Error loading product data:', error);
      setRelatedProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchRelatedProducts = async (productId, categoryId) => {
    try {
      const url = `https://demo-site.storii.com.pk/demo-api/get-related-products.php?product_id=${productId}${categoryId ? `&category_id=${categoryId}` : ''}`;
      const response = await fetch(url);

      if (!response.ok) {
        console.error(`[RelatedProduct] HTTP ${response.status} from get-related-products.php`);
        setRelatedProducts([]);
        return;
      }

      const data = await response.json();

      if (data.success && data.products && data.products.length > 0) {
        const filtered = data.products.filter(p => p.id !== parseInt(productId));
        setRelatedProducts(filtered.slice(0, 4));
      } else {
        setRelatedProducts([]);
      }
    } catch (error) {
      console.error('[RelatedProduct] Fetch error:', error);
      setRelatedProducts([]);
    }
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) {
      return 'https://via.placeholder.com/300x300?text=No+Image';
    }
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
    return `${IMAGE_BASE_URL}${cleanPath}`;
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Nothing to show if this category has no other products — don't render
  // an empty "You May Also Like" heading with nothing under it.
  if (relatedProducts.length === 0) {
    return null;
  }

  return (
    <div className="related-page">
      <div className="related-container">
        <section className="you-may-also-like-section">
          <div className="ryl-header-row">
            <div>
              <h2 className="ryl-title">You May Also Like</h2>
              <p className="ryl-subtitle">More from {product?.category || 'this category'}.</p>
            </div>
            <Link to={`/shop?category=${product?.category || ''}`} className="ryl-view-all-link">
              View All →
            </Link>
          </div>

          <div className="ryl-grid">
            {relatedProducts.map((item) => (
              <div
                key={item.id}
                className="ryl-card group"
                onClick={() => handleProductClick(item.id)}
              >
                <div className="ryl-image-wrap">
                  <img
                    src={getImageUrl(item.image)}
                    alt={item.name}
                    className="ryl-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/300x300?text=No+Image';
                    }}
                  />
                </div>
                <h3 className="ryl-name">{item.name}</h3>
                <div className="ryl-price-row">
                  <span className="ryl-price">PKR {item.price?.toLocaleString() || '0'}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default RelatedProduct;